var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-content"},[_c('UserHeadline',{attrs:{"title":_vm.$t('SelfServiceForm.title'),"icon":"user"}}),_c('div',{staticClass:"page-content__container"},[_c('SelectContract'),_c('UsersTable')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }